<template>
  <div class="bg-blue-100 p-4 rounded-md space-y-4">
    <slot />
  </div>
</template>
